import React, { useEffect, useReducer, useState } from 'react';
import IUser from 'src/app/authentication/~store/models/User';
import {LicenseExpiresDialogProps} from './~types/LicenseExpiresDialogProps';
import { useTranslation } from 'react-i18next';
import './LicenseExpiresDialog.css';
import { getUsedMailingsCountAsync } from '../../mailing/~api/actions';
import { getUsedSearchStatsAsync } from '../../nlp/~api/actions';

type LIC_TYPES = "DAYSLEFT" | "MAILINGSLEFT" | "NLPSLEFT";

const LicenseExpiresDialog = (props: LicenseExpiresDialogProps) => {
    const [_, forceUpdate] = useReducer((x) => x + 1, 0);
    const [usedMailings, setUsedMailings] = useState<number>(0);
    const [usedNlps, setUsedNlps] = useState<number>(0);
    const { t } = useTranslation();

    useEffect(() => {
        const user: IUser = JSON.parse(sessionStorage.getItem('user') ?? "");
        if (!user.licExpirationInfo.totalMailingsClosed) {
            _getUsedMailingsCount();
        }
        if (!user.licExpirationInfo.totalNlpsClosed) {
            _getUsedNlpsCount();
        }
    }, []);

    const _getUsedMailingsCount = async () => {
        var result = await getUsedMailingsCountAsync();

        if (result.isSuccess && result.value != null) {
            setUsedMailings(result.value);
        }
        else {
            console.error("LicenseExpiresDialog._getUsedMailingsCount failed.");
        }
    }

    const _getUsedNlpsCount = async () => {
        var result = await getUsedSearchStatsAsync();

        if (result.isSuccess && result.value != null) {
            setUsedNlps(result.value);
        }
        else {
            console.error("LicenseExpiresDialog._getUsedNlpsCount failed.");
        }
    }

    const _onCloseLicDialog = (lic: LIC_TYPES) => {
        const user: IUser = JSON.parse(sessionStorage.getItem('user') ?? "");
        switch (lic) {
            case "DAYSLEFT":
                user.licExpirationInfo.licenseDaysLeftClosed = true;
                break;
            case "MAILINGSLEFT":
                user.licExpirationInfo.totalMailingsClosed = true;
                break;
            case "NLPSLEFT":
                user.licExpirationInfo.totalNlpsClosed = true;
                break;
        }
        sessionStorage.setItem('user', JSON.stringify(user));
        forceUpdate();
    };

    const _renderLicenseDaysLeft = (user: IUser) => {
        if (!user.licExpirationInfo.licenseDaysLeftClosed && user.licExpirationInfo.licenseDaysLeft <= 30) //shows if 30 days left
            return _renderLicExpiresDialog("DAYSLEFT", t('license.licenseExpiresPart', { days: user.licExpirationInfo.licenseDaysLeft }));
    }

    const _renderMailingsLeft = (user: IUser) => {
        if (!user.licExpirationInfo.totalMailingsClosed && user.licExpirationInfo.totalMailings > 0 && (usedMailings / user.licExpirationInfo.totalMailings * 100) >= 80) //shows Mailing if more than 80% used
            return _renderLicExpiresDialog("MAILINGSLEFT", t('license.mailingExpires', { mailingUsed: usedMailings, totalMailings: user.licExpirationInfo.totalMailings }));
    }

    const _renderNlpsLeft = (user: IUser) => {
        if (!user.licExpirationInfo.totalNlpsClosed && user.licExpirationInfo.totalNlps > 0 && (usedNlps / user.licExpirationInfo.totalNlps * 100) >= 80) //shows Nlp if more than 80% used
            return _renderLicExpiresDialog("NLPSLEFT", t('license.nlpExpires', { nlpUsed: usedNlps, totalNlps: user.licExpirationInfo.totalNlps }));
    }

    const _renderLicExpiresDialog = (lic: LIC_TYPES, message: string) => {
        return (
            <div className='license-expires-dialog-container' onClick={() => _onCloseLicDialog(lic)}>
                <div className='license-expires-dialog-container__text'>
                    {message}
                </div>
                <div className="close-dialog-button">
                    <img onClick={() => _onCloseLicDialog(lic)}></img>
                </div>
            </div>
        )
    }

    try {
        const user: IUser = JSON.parse(sessionStorage.getItem('user') ?? "");
        return (
            <div className='license-info-container'>
                {_renderLicenseDaysLeft(user)}
                {_renderMailingsLeft(user)}
                {_renderNlpsLeft(user)}
            </div>
        );
    }
    catch {
        return(
            <></>
        );
    }
}

export default LicenseExpiresDialog;